import * as P from "fp-ts-routing";

export type ReportsRoute = {};

export const reportsPageMatch = P.lit("reports");
